<script setup lang="ts">
const travelData = useTravelDataStore();
const { fetchGeoIpLocation } = useGeoIpLocation();
const { modals } = useModal();

// Use onmounted to ensure the call is made client-side to have the ip from the user used and not the server
onMounted(() => {
  travelData.initPriceType(fetchGeoIpLocation);
});
</script>

<template>
  <Teleport to="body">
    <component v-if="modals.length" :is="modals[0].component" />
  </Teleport>
  <div id="app">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<style lang="scss">
@use "@/assets/styles/app";

.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}
</style>
